import { Stream, MediaDeviceInfo } from 'agora-rtc-sdk'
import { useState, useEffect } from 'react'
import { filterInputDevices } from 'components/features/videoCalls/agoraHelpers'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

const kindToDeviceKey = {
  audioinput: 'audioInputDeviceId' as const,
  audiooutput: 'audioOutputDeviceId' as const,
  videoinput: 'videoInputDeviceId' as const,
}

export const useDevices = (stream: Stream | undefined, kind: MediaDeviceKind) => {

  const [cache, render] = useState({})
  const deviceId = useStoreSelector((state) => state.app.videoCall.localStream[kindToDeviceKey[kind]])

  useEffect(() => {
    if (!stream) {
      return
    }
    let isDestroyed = false

    const handler = () => {
      if (isDestroyed) {
        return
      }
      render({})
    }
    stream.on('player-status-change', handler)

    return () => {
      isDestroyed = true
    }
  }, [stream])

  const [devices, setDevices] = useState<MediaDeviceInfo[]>([])
  useEffect(() => {
    let isDestroyed = false

    filterInputDevices(kind)
      .then((nextDevices) => {
        if (isDestroyed) {
          return
        }
        setDevices((prevDevices) => {
          try {
            if (!prevDevices || prevDevices.length !== nextDevices.length) {
              return nextDevices
            }

            const changed = nextDevices.some((nextDevice, index) => {
              const prevDevice = prevDevices[index]
              return prevDevice.deviceId !== nextDevice.deviceId || prevDevice.label !== nextDevice.label
            })

            if (changed) {
              return nextDevices
            }
            return prevDevices
          } catch (e) {
          }
          return prevDevices
        })
      }).catch(() => { /* do nothing */ })

    return () => {
      isDestroyed = true
    }
  }, [cache, kind, deviceId])

  return devices
}
